module.exports = __webpack_public_path__ + "static/about_kenz-0a9174c33d2ef9d08c3505c175968eee.jpg";